module.exports = KsysAppTemplateV2dot67dot2;